<template>
  <svg
    :style="{ color: iconColor || '#000' }"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
    stroke="currentColor"
    stroke-width="20"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="20"
    height="20"
  >
    <path
      d="M256 40c-24.3 0-40.6 23.4-61.3 32.9-20.7 9.5-49.8 1.2-67.1 18.5S111 129.9 101.5 150.6C92 171.3 68.6 187.6 68.6 212s23.4 40.6 32.9 61.3c9.5 20.7 1.2 49.8 18.5 67.1 17.3 17.3 46.5 8 67.1 18.5 20.7 10.5 37 33.9 61.3 33.9s40.6-23.4 61.3-32.9c20.7-9.5 49.8-1.2 67.1-18.5 17.3-17.3 8-46.5 18.5-67.1 10.5-20.7 33.9-37 33.9-61.3s-23.4-40.6-32.9-61.3c-9.5-20.7-1.2-49.8-18.5-67.1-17.3-17.3-46.5-8-67.1-18.5C296.6 63.4 280.3 40 256 40z"
    />
    <circle cx="256" cy="212" r="90" />
    <path
      d="M256 162l20 40 44 6-32 30 8 44-40-21-40 21 8-44-32-30 44-6 20-40z"
    />
    <path
      d="M186 382l-70 21 30 60 40-45 35 44-35-80zM326 382l70 21-30 60-40-45-35 44 35-80z"
    />
  </svg>
</template>

<script>
export default {
  name: "RewardIcon",
  props: {
    iconColor: {
      type: String,
      default: "#000000"
    }
  }
};
</script>
